var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCatalogMenu6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 19V9.86265C20 7.24692 18.9464 4.73831 17.0711 2.8887C15.1957 1.0391 12.6522 0 10 0C7.34783 0 4.8043 1.0391 2.92893 2.8887C1.05357 4.73831 0 7.24692 0 9.86265V19C0 19.5523 0.447714 20 0.999999 20H5.71618V6.18051C5.71694 6.03677 5.77517 5.89913 5.87823 5.79749C5.98128 5.69585 6.12084 5.63842 6.26658 5.63767H13.4881C13.6338 5.63843 13.7734 5.69586 13.8764 5.7975C13.9795 5.89914 14.0377 6.03677 14.0385 6.18051V20H19C19.5523 20 20 19.5523 20 19ZM6.81738 19.9999V6.72329H12.9381V19.9999H6.81738ZM9.25564 14.7461C9.35886 14.6443 9.41685 14.5062 9.41685 14.3623V12.361C9.41685 12.217 9.35886 12.0789 9.25564 11.9771C9.15242 11.8753 9.01243 11.8181 8.86646 11.8181C8.72048 11.8181 8.58048 11.8753 8.47726 11.9771C8.37404 12.0789 8.31606 12.217 8.31606 12.361V14.3623C8.31606 14.5062 8.37404 14.6443 8.47726 14.7461C8.58048 14.8479 8.72048 14.9051 8.86646 14.9051C9.01243 14.9051 9.15242 14.8479 9.25564 14.7461Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 9.99995,
    y1: 0,
    x2: 9.99995,
    y2: 19.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F28F14"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogMenu6);
export default __webpack_public_path__ + "static/media/catalog-menu-6.a09725158be8868b37d7d97a170191da.svg";
export { ForwardRef as ReactComponent };